<template>
  <BaseBlock
    amplitude-opportunity-type-name="backboxes-to-boost-dashboard"
    :metric
    :should-show-backbox-price="false"
    :translations
    @on-open="handleOnOpen"
    @on-pagination-changed="handleOnPaginationChanged"
    @on-update="$emit('on-update')"
  />
</template>

<script setup lang="ts">
import type { sellerOpportunities } from '@backmarket/http-api'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import BaseBlock from '../BaseBlock/BaseBlock.vue'

import translations from './BlockBackboxesToBoost.translations'

const { trackPaginationClicked, trackClick } = useTracking()

defineProps<{
  metric: sellerOpportunities.PricingOpportunitiesMetric
}>()

defineEmits(['on-update'])

function handleOnPaginationChanged() {
  trackPaginationClicked({
    name: 'pagination_clicked',
    page_type: 'opportunities_pricing',
    zone: 'opportunities_pricing_backbox_to_boost_lists',
  })
}

function handleOnOpen() {
  trackClick({
    name: 'backboxes-to-boost',
    page_type: 'opportunities_pricing',
    zone: 'opportunities_pricing_dashboards',
  })
}
</script>
